module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABWklEQVQ4T42Sv0vDQBTHv0+LFBp/DYW6FcRFHFzcdSw46BIXh2TQKkFXXYQT/wCnQotDsmkjbo7+AY6CDoUKVamk4OBgY0tN8uRaiyE01ZuO4z73fe/dhwCgULCV0RRMAq8ClJRn0cWAR+Brj2nX0NUGyQtFy74kwqMTuMdC19uDQGGayQwpJwReyGtqrguWrHLL4c/pOKj/kBAikcnOvzfYTf+ANuc1tbvvPXQx6zxVnoUQXjS9ZNm1gP2VGNCuSoDAh9vaxlUY/gusAchKgMG3PtO6HEivmuGJIRAPna9Obn9rs/4fsMqAQkFw5LxUrHCvQxMLpr34BrcyaMpDwUH/+DvxmB5PTXNqfGxiMgrXq/evsuRIYrnluZQ2DLVZtGyTAC0MSt18xpKhq3dFy/7wGXN9c84Z1PZd7Ek4TrmZEeWAmZd3NLUngJQ8keIzAGtDJG8S+KYv+TdMwOWzLF7m4AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/qywk.png
// module id = SfTx
// module chunks = 96